export const GET_QUESTIONS_ANSWERS = "GET_QUESTIONS_ANSWERS";
export const SET_QUESTIONS_ANSWERS = "SET_QUESTIONS_ANSWERS";
export const UPDATE_RESPONSE = "UPDATE_RESPONSE";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const SET_REASON_OF_UNSATISFIED_RESPONSE = "SET_REASON_OF_UNSATISFIED_RESPONSE";

export const getQuestionsAnswers = () => ({
	type : GET_QUESTIONS_ANSWERS
});
export const setQuestionsAnswers = (obj) => ({
	type : SET_QUESTIONS_ANSWERS,
	obj
});

export const updateResponse = () => ({
	type: UPDATE_RESPONSE
});

export const updateQuestion = (id, state, comment) => ({
	type: UPDATE_QUESTION,
	id,
	state,
	comment
});

export const setReasonOfUnsatisfiedResponse = (value) => ({
	type: SET_REASON_OF_UNSATISFIED_RESPONSE,
	value
});

